const initialState =[
    {
        id:1,
        img:'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        catagory:'Article',
        title:'Boost your conversion rate',
        author:'Learn with sumit',
        author_url:'https://avatars.githubusercontent.com/u/73503432?v=4',
        date:'11 Jul, 2022',
        readTime:'6 min read'
    },
    {
        id:2,
        img:'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        catagory:'Blog',
        title:'How to use search engine optimization to drive sales',
        author:'Learner imran',
        author_url:'https://avatars.githubusercontent.com/u/73503432?v=4',
        date:'11 Jul, 2022',
        readTime:'6 min read'
    },
    {
        id:3,
        img:'https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        catagory:'Article',
        title:' Improve your customer experience',
        author:'Learn with sumit',
        author_url:'https://avatars.githubusercontent.com/u/73503432?v=4',
        date:'11 Jul, 2022',
        readTime:'6 min read'
    },
    {
        id:4,
        img:'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        catagory:'Blog',
        title:'Boost your conversion rate',
        author:'Learner imran',
        author_url:'https://avatars.githubusercontent.com/u/73503432?v=4',
        date:'11 Jul, 2022',
        readTime:'6 min read'
    },
    {
        id:5,
        img:'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        catagory:'Article',
        title:'How to use search engine optimization to drive sales',
        author:'Learn with sumit',
        author_url:'https://avatars.githubusercontent.com/u/73503432?v=4',
        date:'11 Jul, 2022',
        readTime:'6 min read'
    },
    {
        id:6,
        img:'https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
        catagory:'Blog',
        title:' Improve your customer experience',
        author:'Learner imran',
        author_url:'https://avatars.githubusercontent.com/u/73503432?v=4',
        date:'11 Jul, 2022',
        readTime:'6 min read'
    },
    
    
]
export default initialState;